import { FC } from 'react';
import { Container } from '../container';
import { Chapter_1 } from './chapter_1';
import { Chapter_2 } from './chapter_2';
import { Chapter_3 } from './chapter_3';
import { Chapter_4 } from './chapter_4';
import { Chapter_5 } from './chapter_5';
import { Chapter_6 } from './chapter_6';
import { Chapter_7 } from './chapter_7';
import { Chapter_8 } from './chapter_8';
import { Chapter_9 } from './chapter_9';
import {
  TimelineContainer,
  TimelineLine,
  TimelineTitle,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
} from './styled';
import { texts } from '../locale';
type Props = {
  scrollUp: boolean;
  isOpen: boolean;
};
export const Timeline: FC<Props> = ({ scrollUp, isOpen }) => {
  //console.log(typeof texts.timelines[0].events[2].content[1]);
  return (
    <TimelineContainer $isOpen={isOpen}>
      <TimelineLine />

      <Chapter_1 scrollUp={scrollUp} />
      <Chapter_2 scrollUp={scrollUp} />
      <Chapter_3 scrollUp={scrollUp} />
      <Chapter_4 scrollUp={scrollUp} />
      <Chapter_5 scrollUp={scrollUp} />
      <Chapter_6 scrollUp={scrollUp} />
      <Chapter_7 scrollUp={scrollUp} />
      <Chapter_8 scrollUp={scrollUp} />
      <Chapter_9 scrollUp={scrollUp} />

      {/*texts.timelines.map((item, index) => (
        <>
          <TimelineTitle>
            <img src={item.image} />
            <h2>
              <span>{index + 1}</span>
              {texts.timelines[index].title}
            </h2>
          </TimelineTitle>
          <Container>
            <TimelineIntro>{texts.timelines[index].intro}</TimelineIntro>
            {item.events.map((event, index) => (
              <>
                <TimelineSubtitle>
                  <span />
                  {event.date}
                </TimelineSubtitle>
                <TimelineContent>
                  {event.content.map((content, index) =>
                    typeof content === "object" ? (
                      //content.includes("https:") ? (
                      <TimelineImage>
                        <img src={content[0]} />
                        <span>{content[1]}</span>
                      </TimelineImage>
                    ) : content === "read more" ? (
                      <button>{content}</button>
                    ) : (
                      <p dangerouslySetInnerHTML={{ __html: content }}></p>
                    )
                  )}
                </TimelineContent>
              </>
            ))}
          </Container>
        </>
                    ))*/}
    </TimelineContainer>
  );
};
